// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { Button, Heading, Modal, Row } from "@hex-insights/core";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import {
	ColumnFilterFormController,
	NewsletterFilterForm,
	NewsletterForm,
	NewsletterIndex,
	NewsletterOrderForm,
	Tile,
	useColumnFilterFormStateWithQueryStateSync,
} from "@s-i-s-i/see-learning.shared";
import { Main } from "../../../../Components";
import { PermissionedRedirectToHome } from "../../Components";
import { newsletterHubDetailPageInfo } from "../DetailPage/pageinfo";
import { newsletterHubIndexPageInfo } from "./pageinfo";

export function NewsletterHubIndexPage() {
	useActivePageRegistration(newsletterHubIndexPageInfo);

	const index = NewsletterIndex.useIndex();
	const columnFilterFormState = useColumnFilterFormStateWithQueryStateSync(NewsletterIndex.columnNames);

	const { isModalOpen, openModal, closeModal } = Modal.useToggle(false);

	const { push: pushHistory } = useHistory();
	const onSuccess = React.useCallback<NewsletterForm.ControlledCreateProps["onSuccess"]>(
		(_formState, { id }) => {
			pushHistory(newsletterHubDetailPageInfo.to(id));
		},
		[pushHistory],
	);

	return (
		<Main>
			<PermissionedRedirectToHome model="Newsletter" />

			<Row justify="space-between" align="center" style={{ margin: "var(--heading--level-1---margin)" }}>
				<Heading.H1 noMargin>Newsletters</Heading.H1>

				<Button variant="primary" onClick={openModal}>
					New Newsletter
				</Button>
			</Row>

			<Tile>
				<Tile.Body>
					<Row
						justify="spaced-start"
						align="center"
						horizontalSpacing="1rem"
						withVerticalSpacing
						overflow="wrap"
						style={{ marginBottom: "0.75rem" }}
					>
						<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem" withVerticalSpacing overflow="wrap">
							<NewsletterFilterForm.Search formState={index.filterFormState} />
							<NewsletterFilterForm.FilterController
								formState={index.filterFormState}
								numActiveFilters={index.numActiveFilters}
								clearFilters={index.clearFilters}
							/>
							<NewsletterOrderForm.OrderController formState={index.orderFormState} />
							<ColumnFilterFormController formState={columnFilterFormState} />
						</Row>

						{/* Add quick filters here */}
					</Row>

					<NewsletterIndex.IndexTable {...index} columns={columnFilterFormState.formValues} />
				</Tile.Body>
			</Tile>

			<Modal.If condition={isModalOpen}>
				<Modal size="small" onClose={closeModal}>
					<Modal.Header>
						<Heading.H2 noMargin>New Newsletter</Heading.H2>
					</Modal.Header>
					<Modal.Body>
						<NewsletterForm.ControlledCreate onSuccess={onSuccess} />
					</Modal.Body>
				</Modal>
			</Modal.If>
		</Main>
	);
}
